function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.67 13.92c-.74 0-1.33.6-1.33 1.34 0 .74.6 1.33 1.33 1.33.74 0 1.34-.6 1.34-1.33 0-.74-.6-1.34-1.34-1.34z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2zm.93 7.8c0 .61-.26 1.15-.7 1.47-.28.2-.62.31-.98.31a2.1 2.1 0 01-.64-.11l-2.29-.76c-.01 0-.03-.01-.04-.02v4.56c0 1.54-1.26 2.8-2.8 2.8-1.54 0-2.8-1.26-2.8-2.8 0-1.54 1.26-2.8 2.8-2.8.49 0 .94.14 1.34.35V8.02c0-.61.26-1.15.7-1.47.45-.32 1.04-.4 1.62-.2l2.29.76c.86.29 1.51 1.19 1.51 2.09v.6h-.01z"
})));